import { useBreakpointV2 } from "@tm/ui-widgets";
import dynamic from "next/dynamic";
import { useEffect, useState } from "react";
import { generateChatConfigFromURL } from "../../utils/travelFlexConfig";

// Import the actual TravelPlexBot implementation
const TravelplexBotIcon = dynamic(
  () => import("@travelplex/floating-icon-web"),
  {
    ssr: false, // This ensures the component only loads on client side
    loading: () => null, // No loading component
  }
);

const TravelPlexBot = ({ view }: { view: string | undefined }) => {
  const device = useBreakpointV2();
  const [isClient, setIsClient] = useState(false);

  const chatConfig = generateChatConfigFromURL(view || "LANDING");

  useEffect(() => {
    setIsClient(true);
  }, []);

  const handleGetMetaDataMessage = () => {
    // Navigate to the appropriate section in your app
    const iframe = document.getElementById(
      "myra-assistive-app"
    ) as HTMLIFrameElement;
    if (iframe && iframe?.contentWindow) {
      iframe?.contentWindow?.postMessage(
        {
          type: "CHAT_BOT__GET_META_DATA",
          payload: JSON.stringify({
            chatConfig,
          }),
        },
        "*"
      );
    }
  };

  const persusasions = [
    {
      html: "<span style='line-height:14px; font-family: Lato;'><span style='color:#000; font-size:16px;font-weight:400;'>Hey </span><span style='background-image: linear-gradient(to  left, #824BC4, #5735B8); background-clip: text; -webkit-text-fill-color: transparent;font-size:18px;font-weight:900;line-height:20px;'><b>I am Myra</b></span></span>",
    },
  ];

  // Only render on client side
  if (!isClient) {
    return null;
  }

  const params = {
    key: "value1",
  };

  return (
    <TravelplexBotIcon
      trackingData={{ pdtTrackingData: {}, omnitureTrackingData: {} }}
      lob="Insurance"
      platform={device === "lg" ? "desktop" : "pwa"}
      shouldDoCenterAnimation
      shouldAlwaysDoTextScrollAnimation
      persuasions={persusasions}
      onBotGetMetaDataEvent={handleGetMetaDataMessage}
      // onBotEvent={handleBotEvent}
      params={params}
    />
  );
};

export default TravelPlexBot;
